import { z } from "zod";
import { BladeHeaderSchema } from "../../fragments";
import { BackdropSchema } from "../../fragments";
import { ActionSchema } from "../../fragments";
import { BladeCommonSchema } from "../common";
import { AnalyticsSchema } from "../../fragments";
import { MediaSchema } from "../../fragments";
import { CharacterRoleSchema } from "../../fragments";
const RoleSchema = z.object({
    id: z.string(),
    name: z.string(),
});
const CharacterItemSchema = z.object({
    media: MediaSchema,
    title: z.string(),
    role: CharacterRoleSchema.optional(),
    action: ActionSchema.optional(),
    analytics: AnalyticsSchema.optional(),
});
const CharacterListBladeTypeValues = ["characterCardGrid", "characterCardGridMini"];
export const CharacterListBladeTypesSchema = z.enum(CharacterListBladeTypeValues);
export const CharacterListBladeTypes = CharacterListBladeTypesSchema.enum;
export const CharacterListBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    items: z.array(CharacterItemSchema),
});
export const CharacterListBladesContractSchema = CharacterListBladeSchema.extend({
    type: CharacterListBladeTypesSchema,
});
export const CharacterCardGridContractSchema = CharacterListBladesContractSchema.extend({
    type: z.literal(CharacterListBladeTypes.characterCardGrid),
});
export const CharacterCardGridMiniContractSchema = CharacterListBladesContractSchema.extend({
    type: z.literal(CharacterListBladeTypes.characterCardGridMini),
});
//# sourceMappingURL=index.js.map